import {
  Component,
  inject,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  combineLatest,
  map,
} from 'rxjs';
import {TranslatePipe} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {AppState} from '../../store/store';
import {
  selectBrokerName,
  selectContactLanguage,
} from '../../store/contact/contact.selectors';
import {selectPortalLanguage} from '../../store/portal/portal.selectors';
import {selectLoggedIn} from '../../store/auth/auth.selectors';

@Component({
  selector: 'app-footer-info',
  imports: [
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './footer-info.component.html',
  styleUrl: './footer-info.component.scss',
})
export class FooterInfoComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  readonly brokerName$ = this.store.select(selectBrokerName);

  public language$ = combineLatest([
    this.store.select(selectLoggedIn),
    this.store.select(selectPortalLanguage),
    this.store.select(selectContactLanguage),
  ]).pipe(
    map(([loggedIn, portalLanguage, contactLanguage]) => (loggedIn ? portalLanguage : contactLanguage)),
  );

}
